/**
 * API Client Configuration
 * 
 * Axios instance with authentication header injection.
 */

import axios from 'axios';
import { enqueueApiError } from '../observability/reportMetrics';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: Add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('portal_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor: Handle 401 errors + report API failures (no PII)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    // Skip telemetry for the telemetry endpoint itself
    if (!url.includes('/client-metrics')) {
      enqueueApiError({ status, url });
    }

    if (status === 401) {
      // Don't redirect on auth-endpoint failures (login, Google callback,
      // password reset) — those pages render the error themselves.
      if (!error.config?.url?.includes('/portal/auth/')) {
        // Token expired or invalid
        localStorage.removeItem('portal_token');
        localStorage.removeItem('portal_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
